<div style="height: 90vh;" class="d-flex">
  <div class="msb" id="msb">
      <nav class="navbar navbar-default" role="navigation">
        <!-- Main Menu -->
        <div class="side-menu-container">
          <ul class="nav navbar-nav">  
            <li *ngFor="let chat of chats" class="nav-item">        
              <div (click)="showChat(chat.uid)" class="my-3 click-chat">
                <a><i class="fas fa-tachometer-alt"></i>{{chat.name}} {{chat.lastname}}</a>
              </div>
            </li>
          </ul>
        </div><!-- /.navbar-collapse -->
      </nav>
  </div>
  <div *ngIf="setChat && initChat">
    <app-chat  [chatId]='setChat' [localIdType]="localIdType"></app-chat>
  </div>
</div>
